import React, { PropTypes } from 'react';
import { Button, Icon, Modal } from "antd";

export const ObservationDetail = ({ segments, visible, handleCancel}) => {
  const getAlbumCover = (url) => {
    if (url.indexOf('?imgeView2') >= 0 || url.indexOf('?imageMogr2') >= 0) {
      return url;
    }
    return url + '?imageView2/1/w/300';
  }

  return (
    <Modal
          title="查看评价详情"
          visible={visible}
          onCancel={handleCancel}
          footer={null}
          wrapClassName="observation-detail-modal story-modal"
        >
      <div className="observation-component">
        {segments.map(segment => <div key={segment.index}>
          <div className="title">{segment.text}</div>
          <img src={getAlbumCover(segment.image_url)} alt="" className="img" />
        </div>)}
      </div>
    </Modal>
  )
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/development/commonComponent/ObservationDetail.jsx